import { createAction } from 'redux-act';
import type { RepoData } from '#app/pages/Relations/Repos/types/repoTypes';

/** Полезная нагрузка для открытия формы создания/редактирования РЕПО (пустой объект или данные с id и др.). */
export type RepoFormPayload = Partial<Pick<RepoData, 'id'>> & Record<string, unknown>;

/** Полезная нагрузка для открытия формы закрытия РЕПО. */
export type RepoCloseFormPayload = Record<string, unknown>;

export const setRepoModalVisible = createAction<boolean>('SET_REPO_MODAL_VISIBLE');
export const setRepoForm = createAction<RepoFormPayload>('SET_REPO_FORM');
export const closeRepoForm = createAction('CLOSE_REPO_FORM');

export const setRepoCloseModalVisible = createAction<boolean>('SET_REPO_CLOSE_MODAL_VISIBLE');
export const setRepoCloseForm = createAction<RepoCloseFormPayload>('SET_REPO_CLOSE_FORM');
export const closeRepoCloseForm = createAction('CLOSE_REPO_CLOSE_FORM');
